import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App.jsx";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import UserService from "./services/UserService";
import config from "./config/environment.js";
import { initGoogleAnalytics } from "./utils/googleAnalytics";

const queryClient = new QueryClient();

const renderApp = () => {
  const container = document.getElementById("root");
  const root = createRoot(container);

  // Get base path from environment, default to /controlsube for non-production
  const basePath = config.paths.base || "/controlsube/";
  // Remove trailing slash for React Router basename (it doesn't need it)
  const basename = basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
  // Handle root path case
  const routerBasename = basename === "/" ? "" : basename;

  root.render(
    <QueryClientProvider client={queryClient}>
      <Router
        basename={routerBasename}
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <App />
      </Router>
    </QueryClientProvider>
  );
};
UserService.checkSession();
initGoogleAnalytics();
renderApp();
